import React from 'react';
import Table from '../components/Table/Table';
import useViewVisited from '../features/app/hooks/useViewVisted';
import { useSelector } from 'react-redux';
import { toJS } from '../utils/immutableUtils';
import { Tooltip, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import PublishIcon from '@material-ui/icons/Publish';
import PreviewIcon from '@material-ui/icons/ImageSearch';
import Typography from '@material-ui/core/Typography';
import MessageIcon from '@material-ui/icons/Message';
import DataTypes from 'components/Table/dataTypes';
import _ from 'lodash';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import useGlobalStatusPpsis from 'features/PpsiContainer/hooks/useGlobalStatusPpsis';
import usePreviewPpsi from '../features/PpsiContainer/hooks/usePreviewPpsi';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import UpdatesIcon from 'components/common/UpdatesIcon';
import { getLanguage } from 'features/app/selectors';
import { ppsiInProgressRoute } from 'routes';
import { stitchPpis } from '../utils/ui2pStitchPPI';
import stichPpsi from '../utils/ui2pStitchPPSI';
import { States } from '../features/PpiContainer/constants';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import { makeStyles } from '@material-ui/core/styles';

function getData(ppsi) {
  const data = [];
  ppsi.forEach(i => {
    const ppsis = i;
    data.push({ ...ppsis, type: 'PPSI' });
  });
  return data;
}

const useStyles = makeStyles(theme => ({
  tooltip: {
    maxWidth: 450,
    backgroundColor: '#000'
  }
}));

const ApprovalStatusView = () => {
  const [
    isFetchingPpsis,
    globalStatusPpsis,
    errorFetchingPpsis
  ] = useGlobalStatusPpsis();
  const classes = useStyles();
  const ppsi = toJS(globalStatusPpsis, []);
  const language = useSelector(getLanguage);
  // const { ppiDetails, ingredientEntryIds } = ppsi.inProgressPpsiEnrichmentData;
  // const ppiDataIds = getPpiDataIdsFromPpiDetails(ppiDetails);

  // const ppiDataList = useSelector(getPpiDataForIds(ppiDataIds)).toJS();
  // const ingredientEntries = useSelector(
  //   getIngredientEntriesByIds(ingredientEntryIds)
  // ).toJS();

  const [isFetching, getPpis] = usePpis(States.PUBLISHED);
  const localPpis = toJS(getPpis, []);
  const [previewNodePPSI, openPreviewPPSI] = usePreviewPpsi();
  const { isViewVisited } = useViewVisited(
    View.PpsiListGlobalApprovalStatus.name,
    isFetchingPpsis
  );
  const isFetched = isViewVisited ? true : !isFetchingPpsis;

  const Columns = {
    IfoodID: {
      name: 'formulaCode',
      label: 'IFood ID',
      dataField: 'formulaCode',
      //   filterable: true,
      sortable: true,
      width: 100,
      grow: 0,
      shrink: 0
    },
    PresentationName: {
      name: 'presentationName',
      calculateCellValue: rowData =>
        rowData.inProgressPpsiEnrichmentData.info[language].presentationName,
      //   filterable: true,
      sortable: true,
      label: 'Presentation Name',
      width: 290,
      grow: 0,
      shrink: 0,
      link: rowData => ppsiInProgressRoute(rowData.id)
    },
    Type: {
      name: 'type',
      dataField: 'type',
      sortable: false,
      label: 'Type',
      width: 50,
      grow: 0,
      shrink: 0
    },
    ReviewSentDate: {
      name: 'reviewSentDate',
      dataField: `inProgressPpsiEnrichmentData.sendReviewDate`,
      dataType: DataTypes.Date,
      label: 'Review Sent Date',
      searchable: false,
      width: 100,
      grow: 0,
      shrink: 0
    },
    Status: {
      name: 'status',
      dataField: 'inProgressPpsiEnrichmentData.status',
      sortable: false,
      filterable: true,
      label: 'Status',
      width: 160,
      grow: 0,
      shrink: 0
    },
    Comments: {
      name: 'comments',
      // dataField: 'inProgressPpsiEnrichmentData.globalRejectComment',
      calculateCellValue: rowData => {
        const comment =
          rowData.inProgressPpsiEnrichmentData.status === 'GLOBAL REJECTED'
            ? rowData.inProgressPpsiEnrichmentData.globalRejectComment
            : rowData.inProgressPpsiEnrichmentData.status === 'GLOBAL REVIEW'
            ? rowData.inProgressPpsiEnrichmentData.globalReviewComment
            : '';
        return (
          <>
            {comment && comment.length > 50 ? (
              <>
                <Typography variant="body2">
                  {comment.slice(0, 35)}...
                </Typography>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  fontSize={20}
                  title={<Typography variant="body2">{comment}...</Typography>}
                >
                  <IconButton color="action" size="medium">
                    <MessageIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              comment
            )}
          </>
        );
      },
      sortable: false,
      label: 'Comments',
      searchable: false,
      width: 150
      // grow: 0,
      // shrink: 0
    },
    Actions: {
      name: 'action',
      label: '',
      CellValue: ({ rowData }) => {
        return (
          <>
            {rowData.status === 'GLOBAL REJECTED' && (
              <Tooltip title="Go to edit page">
                <IconButton
                  // onClick={() => {
                  //   //  return ppsiInProgressRoute(rowData.id)
                  // }}
                  color="secondary"
                  size="medium"
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {rowData.status === 'GLOBAL APPROVED' && (
              <Tooltip title="Go to publish page">
                <IconButton
                  // onClick={() => {
                  //   //  return ppsiInProgressRoute(rowData.id)
                  // }}
                  color="secondary"
                  size="medium"
                >
                  <PublishIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
      link: rowData => ppsiInProgressRoute(rowData.id),
      grow: 0,
      shrink: 0,
      width: 45,
      searchable: false
    },
    PreviewActions: {
      name: 'previewaction',
      label: 'Actions',
      CellValue: ({ rowData }) => {
        return (
          <>
            {
              <Tooltip title={`Preview ${rowData.type}`}>
                <IconButton
                  onClick={() => {
                    const data = rowData.data.inProgressPpsiEnrichmentData;
                    const { ppiDetails, referencedIFoodData } = data;

                    const ingredientEntries = referencedIFoodData.referencedIngredientEntities.sort(
                      (a, b) => a.lineId - b.lineId
                    );
                    const ppiDataIds = ppiDetails
                      .filter(ppiDetail => ppiDetail.ppiEnrichmentDataId)
                      .map(ppiDetail => ppiDetail.ppiEnrichmentDataId);
                    // const usedPpis =
                    // globalPpis && globalPpis.map(i => i.publishedPPIEnrichmentData);
                    // localPpis && localPpis.map(i => i.publishedPPIEnrichmentData);
                    const usedPpis =
                      localPpis &&
                      localPpis
                        .filter(
                          ppi =>
                            ppi.publishedPPIEnrichmentData &&
                            ppiDataIds.includes(
                              ppi.publishedPPIEnrichmentData.id
                            )
                        )
                        .map(ppi => ppi.publishedPPIEnrichmentData);
                    // const dishCode = {formulaCode: rowData.data.formulaCode}
                    const sendData = {
                      ...data,
                      dish: { formulaCode: rowData.data.formulaCode }
                    };

                    const ppis = stitchPpis(usedPpis);
                    const ppsi = stichPpsi(
                      sendData,
                      ppis,
                      ingredientEntries,
                      language
                    );

                    const getExcludedItemCodes =
                      ppiDetails &&
                      ppiDetails
                        .filter(i => i.ppiNotRequired === true)
                        .map(i => i.itemCode);

                    const ppiWithoutExcludeData =
                      ppsi &&
                      ppsi.ppiDetails.filter(
                        i => !getExcludedItemCodes.includes(i.itemCode)
                      );

                    const finalPpsi = {
                      ...ppsi,
                      ppiDetails: ppiWithoutExcludeData,
                      updateNotificationList: []
                    };

                    openPreviewPPSI(finalPpsi, language);
                  }}
                  color="secondary"
                  size="medium"
                >
                  <PreviewIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            }
          </>
        );
      },
      // link: rowData => ppsiInProgressRoute(rowData.id),
      grow: 0,
      shrink: 0,
      width: 45,
      searchable: false
    },
    Updates: {
      name: 'updates',
      CellValue: ({ rowData }) => {
        const {
          upToDate,
          updateNotificationList
        } = rowData.data.inProgressPpsiEnrichmentData;

        return (
          !upToDate && (
            <UpdatesIcon
              message={updateNotificationList
                .map(notification => notification.message)
                .join(',')}
            />
          )
        );
      },
      label: 'Updates',
      width: 60,
      grow: 0,
      shrink: 0,
      searchable: false,
      sortable: false
    },
    EmptySpace: {
      name: 'itemCode',
      dataField: 'itemCode',
      label: '  '
    }
  };

  if (isFetchingPpsis || isFetching) {
    return <ProgressFullscreen />;
  }

  const ppsis = getData(ppsi);

  View.PpsiListGlobalApprovalStatus.visit();

  return (
    <PaperContainer showProgress={!isFetched}>
      {previewNodePPSI}
      <Table
        title="ppsi.globalApprovalStatusLabel"
        data={ppsis}
        columns={[
          Columns.IfoodID,
          Columns.PresentationName,
          Columns.Type,
          Columns.ReviewSentDate,
          Columns.Status,
          Columns.Comments,
          Columns.Actions,
          Columns.PreviewActions,
          Columns.Updates
        ]}
        // showProgress={isFetchingPpsis}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'reviewSentDate', direction: 'asc' }]}
        selectable
        // onRowClick={viewPublishedPpsi}
      />
    </PaperContainer>
  );
};

export default ApprovalStatusView;
